module.exports = __webpack_public_path__ + "static/src/content/images/home of the brave.9ef1428.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/home of the brave.png
// module id = fIgO
// module chunks = 0